
export class SqlField {
index: number;
name: string;
type: number;
value: Object;
}

